module.exports = __webpack_public_path__ + "media/sweet_potato_origin.fd19c0bd.mp4";